import { useState } from "react";
import { Button } from "@/components/ax/Button";
import { Field } from "@/components/ax/Field";
import { useI18n } from "@/i18n";

export function MfaChallenge({ challenge, onVerify, onCancel, tone }) {
  const { t } = useI18n();
  const [factor, setFactor] = useState(challenge.factors[0]?.uid || ""), [code, setCode] = useState(""), [busy, setBusy] = useState(false), [error, setError] = useState(null);
  const submit = async (event) => {
    event.preventDefault(); if (busy || !/^\d{6}$/.test(code)) return;
    setBusy(true); setError(null);
    try {
      const result = await onVerify(factor, code);
      if (result?.error) setError(t(result.reason === "expired-session" ? "mfa.loginExpired" : result.reason === "unavailable" || result.error === "unavailable" ? "auth.login.unavailable" : "mfa.codeFailed"));
    } catch { setError(t("mfa.codeFailed")); }
    finally { setBusy(false); }
  };
  return <form onSubmit={submit} data-testid="mfa-challenge" className="mt-4">
    <p className="m-0 text-sm leading-5">{t("mfa.challengeNote")}</p>
    {!challenge.factors.length ? <p role="alert">{t("mfa.unsupported")}</p> : <>
      {challenge.factors.length > 1 && <label className="mt-4 block text-sm">{t("mfa.authenticator")}<select className="mt-2 block min-h-[48px] w-full rounded border border-ax-border bg-ax-surface p-2 text-ax-text" value={factor} disabled={busy} onChange={(event) => setFactor(event.target.value)}>{challenge.factors.map((item, index) => <option key={item.uid} value={item.uid}>{item.displayName || `${t("mfa.authenticator")} ${index + 1}`}</option>)}</select></label>}
      <Field className="mt-4" tone={tone} label={t("mfa.code")} value={code} onChange={(event) => { setCode(event.target.value.replace(/\D/g, "").slice(0, 6)); setError(null); }} inputMode="numeric" autoComplete="one-time-code" maxLength={6} disabled={busy} error={error} testId="mfa-code-input" />
      <Button className="mt-4" type="submit" busy={busy} disabled={busy || code.length !== 6} data-testid="mfa-verify-button">{t("mfa.verify")}</Button>
    </>}
    <Button className="ml-2 mt-4" variant="ghost" disabled={busy} onClick={onCancel} data-testid="mfa-cancel-button">{t("acc.photoCancel")}</Button>
  </form>;
}
